import { IntegrateSideMenu } from "@rapid/components/flow/shared/Deploy/IntegrateSideMenu";
import { IntegrateSidebarActions } from "@rapid/components/flow/shared/Deploy/IntegrateSidebarActions";
import { BuildSteps, Flows } from "@rapid/types/flows";
import { SidebarHeader } from "@rapid/components/layout/SidebarHeader";
import { ConfidenceFilterCard } from "./ConfidenceFilterCard";

export function DeploySidebarContent() {
    return (
        <>
            <SidebarHeader title="How do you want to use your model?" />
            <IntegrateSideMenu afterActions={<ConfidenceFilterCard />} hideGradient />
            <IntegrateSidebarActions previousFlow={Flows.BUILD} previousStep={BuildSteps.REVIEW} />
        </>
    );
}
